import BaseComponent from "../../../baseComponent.js";
import InternalEvent from "../../../../core/constants/internalEvent.js";
import WidgetService from "../../../../core/services/widgetService.js";
import {BulletWidgetController} from "./controller";
import styles from './styles.scss';
import Legends from "../timeseries-chart/legend/legends.jsx";
import NumberAbbreviator from "../../../../core/utils/numberAbbreviator";

export default class BulletWidget extends BaseComponent {
  constructor(props) {
    super(props);
    this.animationTimeInMillisecond = 1000;
    this.componentId = props.componentId;
    this.controller = new BulletWidgetController(props.componentId, props.widget.legends, this.update);
    this.state = {
      legends: props.widget.legends
    };
  }

  componentDidMount() {
    this.container = d3.select(this.refs.container);
    WidgetService.addComponentToWidget(this.props.widget.id, this.controller);
    this.subscribe(InternalEvent.Dashboard.WIDGET_RESIZE, payload => this.handleResize(payload));
    this.subscribe(InternalEvent.Dashboard.WIDGET_RESIZE_STOP, payload => this.handleResize(payload));
    this.subscribe(InternalEvent.Dashboard.CHART_LEGEND_UPDATED, payload => this.handleLegendUpdate(payload));
  }

  componentWillUnmount() {
    this.unsubscribeAll();
    this.controller.destroy();
  }

  handleLegendUpdate(payload) {
    if (payload.widgetId === this.props.widget.id) {
      this.setState({legends: WidgetService.getWidget(this.props.widget.id).legends});
    }
  }

  update(data) {
    this.latestData = data;
    let sum = 0;
    data.forEach(d => sum += (d.y || 0));

    this.y = d3.scaleLinear()
      .domain([0, sum])
      .range([0, this.refs.container.clientHeight]);

    data.forEach((d, i) => {
      const block = $(this.refs['block-' + i]);
      block.css({height: this.y(d.y) + "px"});
      $(block.children()[0]).text(this.state.legends[i].parameters.legendLabel);
      $(block.children()[1]).text(NumberAbbreviator.format(d.y));
    });
  }

  handleResize() {
    this.update(this.latestData);
  }

  render() {
    return (
      <div className={styles.container}>
        <div ref="container" style={{flex: 1, maxWidth: '100%'}}>
          {
            this.state.legends.map((l, i) => {
              return <div className={styles.block} ref={'block-' + i}
                          style={{background: l.parameters.legendColor, height: 0}} key={i}>
                <div/>
                <div/>
              </div>
            })
          }
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/bullet/bulletWidget.jsx